import { render, staticRenderFns } from "./GastroVisitaProctologicaViewComponent.vue?vue&type=template&id=76b94a6e"
import script from "./GastroVisitaProctologicaViewComponent.vue?vue&type=script&lang=js"
export * from "./GastroVisitaProctologicaViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports